export enum EFTargetPeriod {
	TwoThousandTwentyFourToTwentyEight = 1,
	TwoThousandTwentyNineToThirtyThree = 2,
}

export interface IEFElementConfiguration {
	key: string;
	name: string;
	weightingPoints: number;
	factor: number;
}

export interface IEFSubCategoryConfiguration {
	key: string;
	name: string;
	defaultRatio: number;
}

export interface IEFTargetPeriod {
	id: EFTargetPeriod;
	name: string;
	startYear: number;
	qualificationThreshold: string;
}

export interface IEFConfiguration {
	periodYearCount: number;
	targetedInvestmentsWeightingPoints: number;
	elements: IEFElementConfiguration[];
	subCategories: IEFSubCategoryConfiguration[];
	targetPeriods: IEFTargetPeriod[];
}

export interface IEFYearTarget {
	year: number;
	nonFungible: number;
	targetedInvestments: number;
	transactionFinancingAndBbgf: number;
	total: number;
	transformationalInfrastructure: number;
	blackAgriculturalFinancing: number;
	affordableHousing: number;
	blackBusinessGrowthFunding: number;
}

export interface IEFTargets {
	nonFungibleFiveYear: number;
	targetedInvestmentsFiveYear: number;
	transactionFinancingAndBbgfFiveYear: number;
	totalFiveYear: number;
	weightingPointsTransformationalInfrastructure: number;
	weightingPointsBlackAgriculturalFinancing: number;
	weightingPointsAffordableHousing: number;
	weightingPointsBlackBusinessGrowthFunding: number;
	transformationalInfrastructureFiveYear: number;
	blackAgriculturalFinancingFiveYear: number;
	affordableHousingFiveYear: number;
	blackBusinessGrowthFundingFiveYear: number;
	years: IEFYearTarget[];
}

export interface IEFTargetSettingsDtoIn {
	scorecardId: string;
	targetPeriodId: EFTargetPeriod;
	applicableYear: number;
	financialYearEnd: string;
	monetaryTargetFiveYear: number;
	ratioTransformationalInfrastructure: number;
	ratioBlackAgriculturalFinancing: number;
	ratioAffordableHousing: number;
	ratioBlackBusinessGrowthFunding: number;
}

export interface IEFTargetSettingsDtoOut extends IEFTargetSettingsDtoIn {
	id: string;
	qualifyingDate: string;
	targets: IEFTargets;
}
